'use es6';

import { Map as ImmutableMap, List, fromJS } from 'immutable';
import { sumCount, TABLE_COLUMNS_FOR_DIMENSION } from './constants';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { getBucketField, isTable } from '../lib/salesAnalytics/helpers';
import { callWidgetDrilldown } from '../lib/salesAnalytics/drilldowns';
const PUSHED = 'PUSHED';
const NOT_PUSHED = 'NOT_PUSHED';
export const getAggregationProps = report => {
  const bucketField = getBucketField(report);
  return isTable(report) ? [bucketField, PUSHED, NOT_PUSHED] : [bucketField, 'pushStatus', sumCount];
};
export const getColumnsForTable = (report, data, onDrilldown) => {
  const dimensions = report.getIn(['config', 'dimensions']);
  const columnsForTable = dimensions.size > 1 ? TABLE_COLUMNS_FOR_DIMENSION : sumCount;
  const columnsWithClick = columnsForTable.map(field => ({
    dataset: 'primary',
    field,
    onClick: callWidgetDrilldown(report, onDrilldown)
  }));
  return [{
    dataset: 'primary',
    field: dimensions.get('0')
  }, ...columnsWithClick];
};
const sortpushcount = (a, b) => {
  if (a[PUSHED] === b[PUSHED]) {
    return b[NOT_PUSHED] - a[NOT_PUSHED];
  }
  return a[PUSHED] < b[PUSHED] ? 1 : -1;
};
const getDealPushPercentage = (pushCount, allcount) => {
  if (pushCount === 0 || allcount === 0) {
    return 0;
  }
  return pushCount / allcount * 100;
};
export const transformResponseForChart = ({
  report,
  response
}) => {
  const responseData = response.get('groups');
  const bucketField = getBucketField(report);
  const dataByBucket = responseData.reduce((collect, point) => collect.update(point.get(bucketField), ImmutableMap({
    [bucketField]: point.get(bucketField)
  }), value => value.set(point.get('pushStatus'), point.get(sumCount))), ImmutableMap());
  const sortedData = dataByBucket.toList().toJS().sort(sortpushcount).reduce((collect, {
    [bucketField]: val,
    NOT_PUSHED: notPushed,
    PUSHED: pushed
  }) => /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  collect.concat(fromJS([{
    [bucketField]: val,
    pushStatus: PUSHED,
    [sumCount]: pushed
  }, {
    [bucketField]: val,
    pushStatus: NOT_PUSHED,
    [sumCount]: notPushed
  }])), List());
  const allDealsCount = response.get('allDealsCount');
  const allDealsWithPushCount = response.get('allDealsWithPushCount');
  const metrics_secondary = getDealPushPercentage(allDealsWithPushCount, allDealsCount);
  return {
    report,
    response,
    datasets: ImmutableMap({
      primary: Dataset({
        data: sortedData
      }),
      summary: Dataset({
        data: fromJS([{
          metrics_primary: allDealsWithPushCount,
          metrics_secondary
        }])
      })
    })
  };
};
export const transformResponseForTable = ({
  response,
  report
}) => {
  const responseData = response.get('groups').toJS().sort(sortpushcount);
  return {
    report,
    response,
    datasets: ImmutableMap({
      primary: Dataset({
        data: responseData,
        paginationSize: response.get('total')
      })
    })
  };
};